var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faqs"},[_vm._l((_vm.page.faqs),function(q){return [_c('h4',{key:'a' + q._id,staticClass:"accordion-toggle"},[_vm._v(_vm._s(q.question))]),_c('div',{key:'q' + q._id,staticClass:"accordion-content",domProps:{"innerHTML":_vm._s(q.answer)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }